import styled, { TC } from '@benzinga/themetron';

export const HorizontalRuleModule = styled(TC.Row)`
  border-top: 1px solid ${props => props.theme.colors.border};
  height: 1px;
  width: 100%;
`;
